<template>
    <div>
        <div class="row">
            <div class="col-md-3 col-sm-12">
                <Jumbotron>
                    <div class="d-flex mt-2">
                        <img src="../assets/svg/flag.svg" alt="" srcset="" width="30" class="mb-3" />
                        <h4 class="heading ms-3">Training Center</h4>
                    </div>
                    <p class="sub-heading mb-2">
                        Task assigner helps you to assign tasks for the specific employee, select and assign task by
                        respective order.
                    </p>
                    <div class="d-flex gap-2">
                        <Button
                            label="Create"
                            @onClick="toggleCreateTrainingModal()"
                            class="qb-btn qb-btn-primary-md my-2 w-100"
                        />
                        <Button
                            label="Assign"
                            @onClick="toggleAssignModal()"
                            class="qb-btn qb-btn-outline-md my-2 w-100"
                        />
                    </div>
                </Jumbotron>

                <div class="mt-2">
                    <Card>
                        <!-- <p class="qb-title m-2">Employee</p> -->
                        <div class="d-flex tab-container gap-2 p-2">
                            <router-link class="tab" to="/training-center/created">Trainings</router-link>
                            <router-link class="tab" to="/training-center/reportees">Reportees</router-link>
                        </div>
                        <hr class="divider mb-2" />
                        <router-view />
                    </Card>
                </div>
            </div>
            <div class="col-md-9 col-sm-12">
                <!-- <Button label="back" class="qb-btn qb-btn-primary-md" @onClick="handleNavigation"/> -->
                <Card>
                    <div v-if="checkTrainingCenterRoute">
                        <p class="route-heading m-3" v-if="!checkTrainingIdInRoute">Select Training</p>
                        <CreatedTrainingDetailPage v-if="checkTrainingIdInRoute" />
                        <div v-else>
                            <hr>
                             <p class="text-center">No Trainings Found</p>
                        </div>
                    </div>
                    <div v-else>
                        <p class="route-heading m-3" v-if="!checkReporteeIdInRoute">Select Reportees</p>
                        <ReporteeTrainingDetailPage v-if="checkReporteeIdInRoute" />
                    </div>
                </Card>
            </div>
        </div>

        <BulkAssign class="mb-2" @close="toggleCreateTrainingModal" :modalActive="createModalActive"></BulkAssign>

        <Modal @close="toggleAssignModal" :modalActive="assignModalActive">
            <h4 class="modal-heading">Assign Training</h4>
            <div class="row">
                <div class="col-12">
                    <SearchDropDown
                        label="Select Training"
                        :selectLabel="training.name || 'Select Training'"
                        placeholder="Enter Training Name to search"
                        v-model="trainingSearchTerm"
                        @callBackValue="handleTrainingChange"
                        :items="trainingListOptions"
                    />
                    <!-- <p class="my-0 help-text">choose a training to assign</p> -->
                    <p class="my-0 mt-3 mb-2 route-heading">Employees *</p>

                    <multiselect
                        class="m-0"
                        v-model="training.users"
                        placeholder="Search for employee name"
                        label="name"
                        track-by="id"
                        @search-change="onChange"
                        :options="employeeListOption"
                        :multiple="true"
                    ></multiselect>
                    <p class="my-1 help-text"><font-awesome-icon icon="fa-solid fa-circle-info" /> select employees whom you want to assign the training</p>
                    <!-- <VueMultiselectComponent
            v-model="training.users"
            :options="employeeListOption"
            placeholder="Search for employee name"
            @search-change="onChange"
          /> -->
                </div>
            </div>
            <Button
                label="Assign"
                class="qb-btn qb-btn-primary-md mt-4"
                @onClick="bulkAssign()"
                :disabled="!validateBulkAssignTraining"
            />
        </Modal>
    </div>
</template>

<script>
import BulkAssign from '../components/BulkAssignModal.vue';
// import VueMultiselectComponent from "vue-multiselect-component";
import Jumbotron from '../components/JumbotronComponent.vue';
import Card from '../components/CardComponent.vue';
// import Input from "../components/TextFieldComponent.vue";
import Modal from '../components/ModalComponent.vue';
// import Badge from "../components/BadgeComponent.vue";
import Button from '../components/ButtonComponent.vue';

import SearchDropDown from '../components/DropDownSearchComponent.vue';
import { createNamespacedHelpers } from 'vuex';
const { mapGetters: mapAuthGetters } = createNamespacedHelpers('Auth');
import Vue from 'vue';

// import draggable from "vuedraggable";

import Multiselect from 'vue-multiselect';

import ReporteeTrainingDetailPage from '../pages/ReporteeTrainingDetailPage.vue';
import CreatedTrainingDetailPage from '../pages/CreatedTrainingDetailPage.vue';

const { mapActions: mapModuleActions, mapGetters } = createNamespacedHelpers('Module');
const { mapActions: userMapActions, mapGetters: userMapGetters } = createNamespacedHelpers('User');
const { mapActions: trainingMapActions, mapGetters: trainingMapGetters } = createNamespacedHelpers('Training');

export default {
    name: 'TrainingCenterPage',
    data() {
        return {
            employeeSearchTerm: '',
            training: {
                id: '',
                name: '',
                users: [],
            },
            reporterList: [],
            createModalActive: false,
            assignModalActive: false,
            selectedModule: {
                id: '',
                name: '',
            },
            trainingSearchTerm: '',
            moduleSearchTerm: '',
            userSearchTerm: '',
            day: [],
            worksheet: {
                name: '',
            },
            activeUser: '',
        };
    },
    components: {
        Jumbotron,
        Card,
        // Input,
        SearchDropDown,
        ReporteeTrainingDetailPage,
        CreatedTrainingDetailPage,
        // VueMultiselectComponent,
        Multiselect,
        // draggable,
        // Badge,
        Button,
        Modal,
        BulkAssign,
    },
    computed: {
        ...mapGetters({
            moduleList: 'getModuleListOptions',
            taskList: 'getTaskList',
        }),
        ...userMapGetters({
            userList: 'getUserList',
            assigneeList: 'getAssigneeList',
            selectedUser: 'getSelectedUser',
            employeeListOption: 'getEmployeeListOptionForBulkAssign',
            workSheetList: 'getWorkSheetList',
            currentworksheet: 'getCurrentWorkSheet',
        }),
        ...trainingMapGetters({
            selectedTraining: "getSelectedTrainingForUserSummary",
            trainingListOptions: 'getTrainingListOptions',
        }),
        ...mapAuthGetters({
            user: 'getUser',
        }),
        validateBulkAssignTraining() {
            return this.training.id && this.training.users.length > 0;
        },
        checkTrainingCenterRoute() {
            return this.$route.name === 'CreatedTrainingPage';
        },
        checkReporteeIdInRoute() {
            return this.$route.query.reporteeId;
        },
        checkTrainingIdInRoute() {
            return this.$route.query.trainingId;
        },
    },
    methods: {
        toggle() {
            this.open = !this.open;
        },
        ...mapModuleActions({
            // setSelectedModule: "SET_SELECTED_MODULE",
            getTaskByModuleId: 'GET_ALL_TASK_BY_MODULE_ID',
            getAllModule: 'GET_ALL_MODULE',
            setTaskList: 'SET_TASK_LIST',
        }),
        ...trainingMapActions({
            getTrainingListOptions: 'GET_TRAINING_LIST_OPTIONS',
            bulkAssignTraining: 'BULK_ASSIGN_TRAINING',
            getUsersForEnrolledTraining: "GET_USERS_FOR_ENROLLED_TRAINING",
        }),
        ...userMapActions({
            getWorkSheetsByUserId: 'GET_ALL_WORKSHEET',
            createWorkSheet: 'CREATE_WORKSHEET',
            assignModuleToUser: 'ASSIGN_WORK_SHEET',
            getEmployeeList: 'GET_EMPLOYEE_LIST',
            getAssigneeList: 'GET_ASSIGNEE_LIST',
            setSelectedUser: 'SET_SELECTED_USER',
            getWorkSheetByUserId: 'GET_WORKSHEET_BY_USER_ID',
            addDayToWorkSheet: 'ADD_DAY_TO_WORKSHEET',
            removeDayFromWorkSheet: 'REMOVE_DAY_FROM_WORKSHEET',
            validateWorkSheet: 'VALIDATE_WORKSHEET',
            removeTaskFromTaskList: 'REMOVE_TASK_FROM_TASKLIST',
        }),
        handleNavigation() {
            window.history.go(-1);
        },
        toggleAssignModal() {
            this.assignModalActive = !this.assignModalActive;
        },
        toggleCreateTrainingModal() {
            this.createModalActive = !this.createModalActive;
        },
        handleTrainingChange({ label, value }) {
            this.training.id = value;
            this.training.name = label;
        },
        createNewWorkSheet() {
            let structureReporterList = this.reporterList.map((data) => {
                return data.id;
            });
            this.createWorkSheet({
                payload: {
                    assignerId: this.user.userId,
                    reporters: structureReporterList,
                    startedDate: new Date(),
                    userId: this.$route.params.userId,
                    worksheet: [],
                    name: this.worksheet.name,
                    status: 'NOT_YET_STARTED',
                },
                successCallback: ({ data }) => {
                    if (data.status === 'OK') {
                        // Vue.$toast.success('Worksheet Created Successfully');
                        // this.toggleCreateWorkSheetModal();
                        this.getWorkSheetsByUserId(this.$route.params.userId);
                        // this.$router.push({
                        //   name: "WorkSheetDetailPage",
                        //   params: {
                        //     userId: data.userId,
                        //     workSheetId: data.id,
                        //   },
                        // });
                        // redirect to worksheet detail page
                        this.$router.push(
                            '/module-assigner/' + this.$route.params.userId + '/worksheet/' + data.data.id
                        );
                        this.worksheet = {
                            name: '',
                        };
                    } else {
                        Vue.$toast.error('Worksheet Created Failed');
                    }
                },
                errorCallback: (err) => {
                    Vue.$toast.error(err.message);
                },
            });
        },
        handleFilterModule({ label, value }) {
            this.selectedModule.name = label;
            this.selectedModule.id = value;
            this.getTaskByModuleId(value);
        },
        handleUser(user) {
            this.$router.push({
                name: 'EmployeeWorkSheetPage',
                params: { userId: user.id },
            });
            this.activeUser = user.id;
            // this.setSelectedUser(user);
            // this.getWorkSheetByUserId(user.id);
        },
        addDay() {
            this.addDayToWorkSheet({
                status: 'NOT YET STARTED',
                taskList: [],
            });
        },
        bulkAssign() {
            const payload = {
                trainingId: this.training.id,
                userIds: this.training.users.map((data) => data.id),
            };

            this.bulkAssignTraining({
                payload,
                successCallback: ({ data }) => {
                    if (data.status === 'OK') {
                        Vue.$toast.success('Training Assigned Successfully');
                        this.training = {
                            id: '',
                            name: '',
                            users: [],
                        };
                        this.getUsersForEnrolledTraining({id:this.selectedTraining.training.trainingId})
                        // this.$emit("this.getUsersForEnrolledTraining({id:this.selectedTraining.training.trainingId, status})")
                        this.toggleAssignModal();
                    } else {
                        Vue.$toast.error('Training Assigned Failed');
                    }
                },
                errorCallback: (err) => {
                    Vue.$toast.error(err.message);
                },
            });
        },
        deleteDay(index) {
            this.removeDayFromWorkSheet(index);
        },
        deleteTask(worksheetIndex, taskId) {
            this.removeTaskFromTaskList({ worksheetIndex, taskId });
        },
        validateTaskList(data, index) {
            const filterEntry = data.filter((item, i) => {
                return data.findIndex((item2) => item2.id === item.id) === i;
            });

            const constructedTaskList = filterEntry.map((task) => {
                return {
                    completedDate: new Date(),
                    link: '',
                    id: task.id,
                    title: task.title,
                    status: task.status ?? false,
                };
            });

            this.validateWorkSheet({ constructedTaskList, index });
        },
        assignModule() {
            let count = 0;

            const constructedWorkSheet = this.workSheetList
                .map((day) => {
                    return (
                        day.taskList.length > 0 && {
                            day: 'DAY_' + ++count,
                            status: day.status && day.status.replaceAll(' ', '_'),
                            taskList: day.taskList.map((task) => {
                                return {
                                    completedDate: task.completedDate ?? new Date(),
                                    link: '',
                                    id: task.id,
                                    status: task.status ?? false,
                                };
                            }),
                        }
                    );
                })
                .filter(Boolean);


            this.assignModuleToUser({
                payload: {
                    assignerId: this.user.userId,
                    reporters: [],
                    id: this.$route.params.workSheetId,
                    name: 'Module 1',
                    userId: this.$route.params.userId,
                    worksheet: constructedWorkSheet,
                },
                successCallback: ({ data }) => {
                    if (data.status === 'OK') {
                        Vue.$toast.success('Task Assigned Created Successfully');
                    } else {
                        Vue.$toast.error('Task Assigned Created Failed');
                    }
                },
                errorCallback: (err) => {
                    Vue.$toast.error(err.message);
                },
            });
        },
        onChange(name) {
            this.getEmployeeList({ name });
        },
        structureData(data) {
            return data.replaceAll('_', ' ');
        },
        filterCompletedTaskList(taskList) {
            return taskList.filter((task) => task.status === true);
        },
        filterAssignedTaskList(taskList) {
            return taskList.filter((task) => task.status === false);
        },
        addTag(newTag) {
            const tag = {
                name: newTag,
                code: newTag.substring(0, 2) + Math.floor(Math.random() * 10000000),
            };
            this.options.push(tag);
            this.value.push(tag);
        },
    },
    watch: {
        moduleSearchTerm(name) {
            this.getAllModule({ name });
        },
        trainingSearchTerm(name) {
            this.getTrainingListOptions({ name });
        },

        userSearchTerm(name) {
            // this.getUserList({ name });
            this.getAssigneeList({ name, designation: this.user.designation });
        },
    },
    created() {
        // this.setSelectedModule({});
        this.setTaskList([]);
        this.getAssigneeList({ name: '', designation: this.user.designation });
        this.getEmployeeList({ name: '' });
        this.getAllModule({ name: '' });
        this.getTrainingListOptions({ name: '' });
    },
    mounted() {
        this.setSelectedUser(null);
    },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss" scoped>
@import '../assets/scss/color.scss';
@import '../assets/scss/font.scss';
@import '../assets/scss/field.scss';

.description-area {
    height: 700px;
}
.bill-board-header {
    background-color: white;
}
.bill-board {
    height: 640px;
    overflow: auto;
}
.active-user {
    background-color: #f1f1f1;
    border-left: 3px solid #1da8d5;
}
.bill-board-entity-title {
    font-size: $font-size-sm;
    font-weight: 500;
    color: $dark-300;
    margin: 0px;
}

.bill-board-entity {
    &:hover {
        cursor: move;
    }
}

.bill-board-entity-complete {
    &:hover {
        cursor: no-drop;
    }
}

// .divider-label {
//   font-size: $font-size-xs;
//   text-transform: uppercase;
//   font-weight: 500;
//   color: $light-500;
//   margin: 0px;
//   width: fit-content;
// }

.check-logo-completed {
    filter: grayscale(0%);
    opacity: 100%;
}

.check-logo-incompleted {
    filter: grayscale(100%);
    opacity: 30%;
}

.task-list-area {
    height: 570px;
    border-radius: $field-border-radius;
    overflow: auto;
    background-color: $light-fade-100;
    margin-top: 10px;
}

.fa-bars {
    font-size: $font-size-sm;
    color: $light-400;
    margin: 0px;
}

.fa-trash {
    font-size: $font-size-sm;
    color: $light-400;
    margin: 0px;

    &:hover {
        cursor: pointer;
    }
}

.fa-download {
    font-size: $font-size-sm;
    color: $light-400;
    margin: 0px;
}

.add-day-title {
    font-size: $font-size-sm;
    margin: 0px;
    font-weight: $font-weight-normal-2;
    color: $dark-300;
    background-color: $light-fade-200;
    padding: 5px 10px;
    border-radius: $field-border-radius;

    &:hover {
        background-color: $light-200;
        cursor: pointer;
    }
}

.bill-board-card {
    width: 100%;
    margin-bottom: 25px;
}

.bill-board-card-header {
    background-color: $light-fade-200;
    padding: 13px 10px;
    border-radius: $field-border-radius;
}

.bill-board-title {
    font-size: $font-size-sm;
    margin: 0px;
    font-weight: $font-weight-normal-2;
    color: $dark-300;
}

.bill-board-hr-scroll {
    height: 100%;
    width: 100%;
    overflow-y: auto;
}

.bill-board-hr-scroll::-webkit-scrollbar {
    background: none;
    width: 5px;
}

.bill-board-hr-scroll::-webkit-scrollbar-thumb {
    background-color: $light-300;
    border-radius: $field-border-radius;
}

.heading {
    font-size: $font-size-xxl;
    font-weight: $font-weight-bold;
}

.sub-heading {
    font-size: $font-size-md;
}

.qb-title {
    font-size: $font-size-md;
    font-weight: $font-weight-bold;
}

.divider {
    border: 0.5px solid $light-500;
    margin: 0px;
}

.tab {
    font-size: $font-size-sm;
    font-weight: $font-weight-normal-2;
    width: fit-content;
    border-radius: $field-border-radius-high;
    padding: 3px 10px;
    text-decoration: none;
    background-color: $light-300;
    color: $dark-300;
}

.tab:hover {
    cursor: pointer;
}

.qb-avatar {
    width: 35px;
    height: 35px;
    border-radius: 100%;
}

.active {
    background-color: $primary-100;
    color: $white;
}

.route-heading {
    font-size: $font-size-md;
    font-weight: $font-weight-bold;
    color: $dark-100;
    margin: 0px;
}

.qb-entity-title {
    color: $dark-200;
    font-size: $font-size-md;
    font-weight: $font-weight-normal-2;
    margin: 0px;
}

.qb-entity-subtitle {
    color: $light-500;
    font-size: $font-size-sm;
    font-weight: $font-weight-normal-1;
    margin: 0px;
}

.list-entity {
    border-bottom: 1px solid $light-200;

    &:hover {
        background-color: $light-100;
        cursor: pointer;
    }
}
.help-text{
    color: $light-500;
    font-weight: $font-weight-bold;
    font-size: $font-size-sm;
}

@media only screen and (max-width: 600px) {
    .bill-board-header {
        position: sticky;
        top: 0%;
        z-index: 2;
    }
    .description-area {
        max-height: 300px;
        overflow: scroll;
    }
    // .bill-board-header{
    //   max-height:300px;
    //     overflow:scroll;
    // }

    .employee-list {
        max-height: 100px;
        overflow-y: scroll;
    }
    .bill-board {
        height: max-content;
        width: 100%;
        overflow-y: auto;
    }
    .task-list-area {
        max-height: 200px;
        overflow: scroll;
    }
}
</style>
